import { render } from "./CommissionParticipantChoose.vue?vue&type=template&id=760eef2d&scoped=true"
import script from "./CommissionParticipantChoose.vue?vue&type=script&lang=js"
export * from "./CommissionParticipantChoose.vue?vue&type=script&lang=js"

import "./CommissionParticipantChoose.vue?vue&type=style&index=0&id=760eef2d&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760eef2d"]])

export default __exports__